import { SVGProps, Ref, forwardRef } from 'react';

export const LocationOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.548 4.543 8.666 2.35C12.361.767 14.208-.025 15.116.884c.909.908.117 2.755-1.466 6.45l-2.193 5.118c-.884 2.06-1.325 3.09-1.995 3.047-.67-.045-.973-1.124-1.577-3.283l-.897-3.204-3.204-.897C1.625 7.511.546 7.21.501 6.538s.987-1.111 3.047-1.995m5.685 7.295-1.11-3.961-3.961-1.11c-.536-.15-.975-.273-1.335-.382.343-.155.761-.336 1.273-.555l5.117-2.193c1.89-.81 3.167-1.353 4.087-1.604.444-.12.681-.138.796-.133.005.115-.012.352-.133.796-.25.92-.794 2.196-1.604 4.087L10.17 11.9c-.22.512-.4.93-.555 1.273-.109-.36-.232-.799-.382-1.335m4.96-9.922s-.01 0-.022-.008a.1.1 0 0 1 .022.008m-.101-.087q-.01-.02-.008-.021.001-.002.008.021"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
LocationOutlinedSize16Glyph.displayName = 'LocationOutlinedSize16Glyph';
